import React,{useEffect,useState} from 'react'
import { CircularProgress } from '@material-ui/core'
import { useDispatch,useSelector } from 'react-redux'
import { setPersist } from 'redux/actions/persist'
import DefaultAva from 'assets/icon/default-ava.jpeg'


export default function Author(props) {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    let {forum_detail}=reducer
    const convertHash=(tag)=>{
        let conv=tag.replace('#','%23')
        return conv
    }
    return (
        <div className='fix-menu-author'>
            <div className='author'>
                {general.isLoadingComment?
                
                <div style={{textAlign:'center'}}>
                    <CircularProgress style={{color:'#ff4e4e'}}  size={35} />
                </div>
                :forum_detail!==null&&
                <div>
                    <div className='div-flex div-justify-between author-head'>
                        <p className='font-nunito margin-0 font-bold'>Dibuat Oleh</p>
                        <p className='font-nunito margin-0 font-bold' style={{color:'#777777'}}>{forum_detail.lastActivity}</p>
                    </div>
                    <div className='author-ava'>
                        <img src={forum_detail.author.profilePic!==''?forum_detail.author.profilePic:DefaultAva}/>
                        <p className='font-nunito font-bold'>{forum_detail.author.name}</p>
                    </div>
                    <p className='font-nunito font-bold'>Tag Diskusi</p>
                    <div className='div-flex div-flex-wrap' >
                        {forum_detail.tags.map((data,i)=>(
                            <a key={i} href={`/search?q=${convertHash(data)}`}><p  className='hashtag-item font-nunito'>{data}</p></a>
                        ))}
                    </div>
                </div>}
               
        </div>
        </div>
    )
}
